const CONTRACT_STATUS_TYPE = {
	ACTIVE: {
		code: "1",
		label: "common.typeList.contractStatus.active"
	},
	COMPLETE: {
		code: "2",
		label: "common.typeList.contractStatus.complete"
	},
	CANCEL: {
		code: "3",
		label: "common.typeList.contractStatus.cancel"
	}
}

export default CONTRACT_STATUS_TYPE
